import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { useMutationWithError } from "@/hooks";
import { api } from "@/lib/api";
import { type Timezones } from "@/types";

export const settings = createQueryKeys("settings", {
  notifications: null,
  timezones: null,
  general: null,
});
export const fetchTimezonesQueryOptions = () =>
  queryOptions({
    ...settings.timezones,
    queryFn: () =>
      api.get<Timezones>(`timezones`).then((response) => response.data),
  });

export const useFetchTimezones = () => {
  return useQuery(fetchTimezonesQueryOptions());
};

export const fetchNotificationSettingsQueryOptions = () =>
  queryOptions({
    ...settings.notifications,
    queryFn: () =>
      api
        .get<Record<string, boolean>>(`me/settings/notifications`)
        .then((response) => response.data),
  });

export const useFetchNotificationSettings = () => {
  return useQuery(fetchNotificationSettingsQueryOptions());
};

export const useUpdateNotificationSettings = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: { notifications: Record<string, boolean> }) =>
      api.put(`me/settings/notifications`, data),
    onSuccess: () => {
      queryClient.invalidateQueries(settings.notifications);
    },
  });
};
